import React from 'react';
import ReactDOM from 'react-dom';
import Root from './boilerplate/Root';
import './index.css';

ReactDOM.render(
  <Root/>,
  document.getElementById('root')
);



// WEBPACK FOOTER //
// ./src/index.js